import { ThemeContextProvider, useThemeContext } from '@/contexts/ThemeContext';
import { getTheme } from '@/styles/antd-theme';
import { LoadingOutlined } from '@ant-design/icons';
import { ConfigProvider, theme } from 'antd';

const customSpinIndicator = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const AntdConfigProvider = ({ children }) => {
  const { isDarkMode, isCompact } = useThemeContext();
  const currentTheme = getTheme(isDarkMode);

  const algorithm = isDarkMode
    ? isCompact
      ? [theme.darkAlgorithm, theme.compactAlgorithm]
      : theme.darkAlgorithm
    : isCompact
      ? [theme.defaultAlgorithm, theme.compactAlgorithm]
      : theme.defaultAlgorithm;

  return (
    <ConfigProvider
      theme={{
        ...currentTheme,
        algorithm,
      }}
      componentSize={isCompact ? 'small' : 'middle'}
      spin={{ indicator: customSpinIndicator }}
    >
      {children}
    </ConfigProvider>
  );
};

const ThemeProvider = ({ children }) => {
  return (
    <ThemeContextProvider>
      <AntdConfigProvider>{children}</AntdConfigProvider>
    </ThemeContextProvider>
  );
};

export default ThemeProvider;
